module.exports = __webpack_public_path__ + "static/media/background_dashboard.ff978a26.jpg";